module.exports = __webpack_public_path__ + "static/media/Writing-Working.1dbd2664.webm";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Writing-Working/Writing-Working.webm
// module id = 433
// module chunks = 0